import { useShallow } from 'zustand/react/shallow';

import { useRoomStore } from '@src/stores';
import { useSettingsContext } from '@src/contexts';

const useSettingsModal = () => {
  const { selectedMenuItem } = useSettingsContext();
  const { isRoomSettingsOpen, setIsRoomSettingsOpen } = useRoomStore(
    useShallow((state) => ({
      isRoomSettingsOpen: state.isRoomSettingsOpen,
      setIsRoomSettingsOpen: state.setIsRoomSettingsOpen,
    }))
  );

  return { isRoomSettingsOpen, selectedMenuItem, setIsRoomSettingsOpen };
};

export default useSettingsModal;
